import { connect } from 'react-redux';
import { compose } from 'redux';
import { withConfig } from 'shell/hoc/withConfig';
import { withLogger } from 'shell/hoc/withLogger';
import { withStyles } from '@material-ui/core/styles';
import { setUser, addNotification } from './actions';
import App from './App';
import styles from './App.styles';

const mapStateToProps = ({ user: { data }, userGroups: { activeADGroup } }) => ({
  isUserLogged: data.logged,
  userId: data.employeeNumber,
  userBrand: data.brand,
  isSuperUser: data.isSuperUser,
  activeADGroup,
  userADGroups: data.groups,
});

const mapDispatchToProps = {
  setUser,
  addNotification,
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withStyles(styles),
  withConfig(),
  withLogger(),
)(App);
